import React from 'react';
import classnames from 'classnames';

import * as S from './Video.module.css';
import * as T from './Video.types';

export const Video: React.FunctionComponent<T.IVideoProps> = ({
  src,
  className,
  ratio = 16 / 9,
}) => {
  const iframeRef = React.useRef<HTMLIFrameElement>();
  const [height, setHeight] = React.useState<number>();

  const resizeVideo = (): void => {
    const element: HTMLIFrameElement = iframeRef.current;

    if (element) {
      const width: number = element.offsetWidth;
      setHeight(width / ratio);
    }
  };

  React.useEffect(() => {
    resizeVideo();

    window.addEventListener('resize', resizeVideo);

    return () => window.removeEventListener('resize', resizeVideo);
  });

  return (
    <iframe
      ref={iframeRef}
      className={classnames(S.video, className)}
      src={src}
      style={{ height }}
      frameBorder={0}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};
